import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FieldGroup, Loader } from '@itds/elements/index.js';
import { CarrierCard } from '@itds/components/index.js';

import { Api } from '@brokerage/utils/Api';

const LimitCarriers = ({ form_engine, saveFormEngine }) => {
  const [data, setData] = useState({
    carrier_ids: form_engine.carrier_ids || []
  });
  const [carriers, setCarriers] = useState([]);
  const [carrier_ids, setCarrierIds] = useState([]);
  const [agency_specific_carriers, setAgencySpecificCarriers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    getData();
  }, []);

  useEffect(() => {
    setData({
      carrier_ids: form_engine.carrier_ids || []
    });
  }, [form_engine]);

  const getData = () => {
    Promise.all([Api.loadFormCarriers(form_engine.is_beta), Api.loadAgencySpecificCarriers()]).then(
      response => {
        const carriers = response[0].data;
        const agency_specific_carriers = response[1].data;

        setCarriers(carriers);
        setCarrierIds(carriers.map(c => c.id));
        setAgencySpecificCarriers(agency_specific_carriers);
        setLoading(false);
      }
    );
  };

  const handleSelectAll = () => {
    if (data.carrier_ids.length !== carrier_ids.length) {
      setData({
        carrier_ids
      });
    } else {
      setData({ carrier_ids: [] });
    }
  };

  const handleCarrierToggle = (carrier, checked) => {
    const is_selected = !checked;

    let selected_carrier_ids = [...data.carrier_ids];

    if (is_selected) {
      selected_carrier_ids.push(carrier.id);
    } else {
      selected_carrier_ids = data.carrier_ids.filter(id => id !== carrier.id);
    }

    setData({
      carrier_ids: selected_carrier_ids
    });
  };

  const save = data => {
    saveFormEngine(data);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div style={{ marginBottom: '30px' }}>
        <Button inline={true} onClick={handleSelectAll.bind(null)} small={true}>
          {data.carrier_ids.length === carrier_ids.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {carriers.map(carrier => {
              const is_selected = data.carrier_ids.includes(carrier.id);

              return (
                <CarrierCard
                  carrier={carrier}
                  isSelected={is_selected}
                  key={carrier.id}
                  onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                />
              );
            })}
          </div>

          <br />
          <FieldGroup contained={true} label='Agency Specific Carriers'>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {agency_specific_carriers.map(carrier => {
                const is_selected = data.carrier_ids.includes(carrier.id);

                return (
                  <CarrierCard
                    carrier={carrier}
                    isSelected={is_selected}
                    key={carrier.id}
                    onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                  />
                );
              })}
            </div>
          </FieldGroup>

          <Button inline={true} onClick={save.bind(null, data)}>
            Save Changes
          </Button>
        </>
      )}
    </>
  );
};

LimitCarriers.propTypes = {
  form_engine: PropTypes.object,
  saveFormEngine: PropTypes.func
};

export default LimitCarriers;
